<template>
<div class="container-fluid">

	<page-loading v-if="!data_loaded" />

	<div v-else class="row">
	    <div class="col-12">
			<div class="d-flex align-items-center">
				<h1 class="flex-grow-1" data-test="pageTitle">Reports</h1>
				<router-link
					:to="{ name: 'reports.create' }"
					v-if="perms.can_create_report"
					v-tooltip.bottom="'Add Report'"
					class="btn btn-sm btn-ghost-primary text-gray-500 cursor-pointer leading-none">
					<i class="far fa-plus-circle text-xl"></i>
				</router-link>
			</div>
		</div>

		<div class="col-12">
			<div v-if="reports.length" class="card-deck">
<!-- 					<router-link :to="{ name: 'reports.test' }">
						Test
					</router-link> -->

				<div v-for="report in reports" class="card report drop-down-hover" style="max-width: 18rem;">
					<div v-if="report.can.update || report.can.delete" class="drop-down dropleft w-100 pt-2 pr-3 text-right">
						<a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							<i class="far fa-ellipsis-h text-xl text-white"></i>
						</a>
						<div class="dropdown-menu py-0" aria-labelledby="dropdownMenuLink">
							<router-link v-if="report.can.update" :to="{ name: 'reports.edit', params: { id: report.id } }" class="dropdown-item">
								Edit Report
							</router-link>
							<span v-if="report.can.delete" class="dropdown-item" @click="deleteReport(report.id)">Delete</span>
						</div>
					</div>

					<router-link :to="{ name: 'reports.show', params: { id: report.id } }">
						<img class="card-img-top" :src="report.thumbnail_url" alt="Thumbnail">
					</router-link>

					<div class="card-body">
						<p class="card-text">
							<router-link :to="{ name: 'reports.show', params: { id: report.id } }">{{ report.title }}</router-link>
						</p>
					</div>
				</div>
			</div>

			<p v-else>No reports found.</p>
		</div>

	</div>
</div>
</template>

<script>
	import { mapState } from 'vuex';
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';

	export default {
        mixins: [BreadcrumbsManager],

		data() {
			return {
				reports: [],
				data_loaded: false,
			}
		},

		created() {
			this.fetchReports();
		},

        activated() {
			this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Reports', to: { name: 'reports.index'} },
            ]); 
        },

		methods: {
            deleteReport(id) {
				Swal.fire({
					title: 'Are you sure?',
					text: 'You will not be able to recover this report.',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Delete report',
					cancelButtonText: 'Keep report',
					animation: false,
                }).then((result) => {
                	if (result.value) {
                        axios.delete('/api/reports/' + id, id).then(() => {
                            this.reports.splice(this.reportIndex(id), 1);
                        })
                    }
                });
            },

			fetchReports() {
				axios.get('/api/reports').then(({data}) => {
                    this.reports = data;
                    this.data_loaded = true;
	            });
			},

        	reportIndex(id) {
                return this.reports.findIndex((element) => {
                    return element.id === id;
                });
        	},  			
		},

		computed: mapState(['perms'])
	}
</script>

<style>
	.report:hover .drop-down {
		box-shadow: inset 0px 40px 25px -25px rgba(0,0,0,.45);
		transition: .15s ease-in all;
	}
	.report .drop-down {
				position:absolute;
		height:50px;
		transition: .15s ease-in all;
	}
</style>